import { AccessLevelSetting } from './AccessLevelSetting'
import { CopyLinkButton } from './CopyLinkButton'
import { GuestAccessList } from './GuestAccessList'
import { InviteGuestClickable } from './InviteGuestClickable'
import { InviteGuestDrawer } from './InviteGuestDrawer'

function Share() {
  return (
    <>
      <InviteGuestDrawer />
      <InviteGuestClickable />
      <GuestAccessList />
      <AccessLevelSetting />
      <CopyLinkButton />
    </>
  )
}

export { Share }
